import type { ReactElement } from 'react'

import { AlertDialog, Button } from '@buffer-mono/popcorn'

type ComponentPropTypes = {
  onConfirm: () => void
  children: ReactElement
}

export const BackToOmniConfirmationModal = ({
  onConfirm,
  children,
}: ComponentPropTypes): ReactElement => {
  return (
    <AlertDialog>
      <AlertDialog.Trigger>{children}</AlertDialog.Trigger>
      <AlertDialog.Content>
        <AlertDialog.Title>You May Lose Your Changes</AlertDialog.Title>
        <AlertDialog.Description>
          Going back to the previous step will discard any changes you&apos;ve
          made for each channel.
        </AlertDialog.Description>
        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary">Cancel</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="critical" onClick={onConfirm}>
              Go Back
            </Button>
          </AlertDialog.Action>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
